<template>    
    <form @submit.prevent="ciSend" v-if="sent === null && contact != null" class="contacts-form">          
        <section :class="{error: isInvalid('fullname')}">
            <label for="fullname">Name (required)</label>
            <input id="fullname" type="text" v-model="contact.fullname">
            <p v-if="isInvalid('fullname')" v-text="getValidationError('fullname')" />
        </section>
        <section :class="{error: isInvalid('email')}">
            <label for="email">Email Address (required)</label>
            <input id="email" type="email" v-model="contact.email">
            <p v-if="isInvalid('email')" v-text="getValidationError('email')" />
        </section>
        <section :class="{error: isInvalid('phone')}">
            <label for="phone">Telephone Number (required)</label>
            <input id="phone" type="text" v-model="contact.phone">
            <p v-if="isInvalid('phone')" v-text="getValidationError('phone')" />
        </section>
        <section :class="{error: isInvalid('company')}">
            <label for="company">Company</label>
            <input id="company" type="text" v-model="contact.company">
            <p v-if="isInvalid('company')" v-text="getValidationError('company')" />
        </section>
        <section :class="{error: isInvalid('message')}">            
            <label for="message">Your Message (required)</label>
            <textarea id="message" v-model="contact.message"></textarea>
            <p v-if="isInvalid('message')" v-text="getValidationError('message')" />
        </section>
        <button>Send</button>
    </form>
    <h3 v-else-if="sent === true">The message has been sent we will be in contact shortly.</h3>
    <h3 v-else-if="sent === false">
        There was a problem sending your message, 
        please try emailing us directly at 
        <a href="mailto:website@argosfranchise.ie">website@argosfranchise.ie</a>
    </h3>
</template>

<script>
// TODO: captcha
import { contactsComputed, contactsMethods } from '../../store'
export default {
    computed: {
        ...contactsComputed        
    },
    data:() => ({    
        validation: null,
        contact: null,  
        sent: null
    }),
    mounted() {
        this.contact = this.contactsSkeleton
    },
    methods: {
        ...contactsMethods,
        ciSend() {
            this.contactsValidate(this.contact)
                .then(res => {
                    this.validation = res
                    if (res.isValid) {
                        this.contactsCreate(this.contact)                    
                        this.validation = null
                        this.sent = true
                    }
                }) 
                .catch(err => this.sent = false)         
        },
        isInvalid(prop) {
            return this.validation && this.validation.messages.find(i => i.key == prop)
        },
        getValidationError(prop) {
            return this.validation && this.validation.messages.find(i => i.key == prop).error
        }       
    }
}
</script>